import cx from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { BlurrableImage } from 'src/client/components/ui/BlurredImage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { MOBILE_LANDSCAPE } from 'src/client/constants/mediaQueries';

type Props = {
  blurred?: boolean;
  className?: string;
  direction: 'previous' | 'next';
  imgSrc: string;
  subText?: string;
  text: string;
  url: string;
};

export const NavigationLink = (props: Props) => {
  const { blurred = false, text, imgSrc, url, direction, className, subText } = props;

  const directionSide = direction === 'previous' ? 'left' : 'right';
  const pullClassName = `pull-${directionSide}`;

  return (
    <StyledNavLink className={cx(pullClassName, direction, className)} to={url}>
      <Arrow icon={direction === 'previous' ? faChevronLeft : faChevronRight} />
      <ImageWrapper>
        <CoverImage src={imgSrc} alt={text} $isBlurred={blurred} />
      </ImageWrapper>
      <Details className={cx('hidden-xs', direction)}>
        <Gallery>{text}</Gallery>
        <Model>{subText}</Model>
      </Details>
    </StyledNavLink>
  );
};

const StyledNavLink = styled(NavLink)`
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) => props.theme.primary3};
  border-radius: 2px;
  padding: 9px;
  display: flex;
  height: 115px;
  transition: 0.3s background-color;
  cursor: pointer;
  overflow-y: hidden;

  &.next {
    flex-direction: row-reverse;
  }

  :hover {
    background-color: ${(props) => props.theme.primary2};
  }

  :hover,
  :focus {
    text-decoration: none;
  }

  @media screen and (max-width: 360px) {
    height: 95px;
  }
`;

const Arrow = styled(FontAwesomeIcon)`
  display: flex;
  width: 40px;
  padding: 0 2.5px;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.primary3};
  font-size: 2.15rem;
  color: ${(props) => props.theme.primary6};

  @media ${MOBILE_LANDSCAPE} {
    width: 50px;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const CoverImage = styled(BlurrableImage)`
  margin: 0 4px;
  max-height: 95px;

  @media screen and (max-width: 360px) {
    max-height: 75px;
  }
`;

const Details = styled.div`
  width: 80px;

  &.previous {
    text-align: left;
    padding-left: 5px;
    margin-right: 16px;
  }

  &.next {
    text-align: right;
    padding-right: 5px;
    margin-left: 16px;
  }
`;

const Gallery = styled.span`
  font-size: 1rem;
  display: block;
  overflow-wrap: break-word;
  color: ${(props) => props.theme.primary4};
`;

const Model = styled.span`
  display: block;
  color: ${(props) => props.theme.primary7};
`;

export default NavigationLink;
